// `Alert` is a global from app/assets/javascripts/modules/alert.coffee, pulled
// in by the dashboard entrypoint. It owns the close-button wiring for anything
// carrying data-rails-rendered-flash, and it is absent on layouts that don't
// load that entrypoint - so its presence also tells you whether a rendered
// close button would do anything.
export interface AlertAPI {
  bindEventsToAlertsFromRails: () => void;
}

export const railsAlert = (): AlertAPI | undefined => (window as unknown as { Alert?: AlertAPI }).Alert;
